<template>
  <div class="toolBar"
  >
    <div class="rightBottomPanel"
      :style="{ left: positionX + 'px', top: positionY + 'px' }"
      @mousedown="startDrag"
      @touchstart="startDrag">

      <div class="item" v-for="(item,index) in items" :key="index" @click="handleClick(index,hasDragged)">
        <img class="icon" :src="item.icon" />
        <div class="iconDot" v-if="newQuoteTag"></div>
        <div class="label">{{item.label}}</div>
      </div>
    </div>
    <ai ref="ai"></ai>
  </div>
</template>
<script>
import ai from '@/components/toolBar/ai';
import io from "@/components/socket.io";
import aEntityAPI from "@/api/aEntityAPI";
import { EventBus } from '@/plugins/http/eventBus.js';
export default {
  components: {
    ai
  },
  data() {
    return {
      items: [
        {
          ref: "ai",
          icon: require("@/assets/chatgpt.png"),
          label: "数字调度员",
        }
      ],
      newQuoteTag:false,
      isDragging: false,
      hasDragged: false, // 新增变量，用于记录是否拖动过
      positionX: 0,
      positionY: 0,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      containerWidth: 0,
      containerHeight: 0,
    };
  },
  mounted() {

    this.initSocket();

    this.existNewQuote();

    let that = this;
    EventBus.$on('openTdoInfoToAiDialog', data=>{
      console.log("openTdoInfoToAiDialog*------------------: ", data);
      that.openTdoInfoToAiDialog(data.tdoId);
    });

    // 获取容器尺寸（可选）
    this.containerWidth = window.innerWidth;
    this.containerHeight = window.innerHeight;
    
    // 设置初始位置（可选）
    this.positionX = this.containerWidth - 100; // 默认靠坐
    this.positionY = this.containerHeight - 100; // 默认底部位置
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 组件销毁前，移除事件监听
    EventBus.$off('openTdoInfoToAiDialog');

    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    openTdoInfoToAiDialog(tdoId) {
      this.$refs.ai.open(tdoId);
    },

    closeBarAiDialog(flag) {
      this.$refs.ai.closeBar(flag);
    },

    handleClick(index,hasDragged) {
       if (hasDragged) return; // 如果拖动过，不执行点击逻辑

      this.newQuoteTag = false;
      this.$refs[this.items[index].ref].open()
    },
    existNewQuote(){
      aEntityAPI.request('ShuntingService','existNewQuote',{}).then((res) => {
        if (res.data.success) {
          if (res.data.data > 0) {
            this.newQuoteTag = true;
          }
          
        }
      });
    },

    //socket ---start-----
    initSocket() {
      let that = this;

      let opts = {
        transports: ["websocket"],
      };

      let wsUrl = "";
      if (process.env.VUE_APP_MODE === "PRO") {
        wsUrl = window.location.protocol + "//" + window.location.hostname + ":3001";
      } else if (process.env.VUE_APP_MODE === "TEST") {
        wsUrl =  window.location.protocol + "//" + window.location.hostname + ":3004";
      } else {
        //开发环境
        // wsUrl = window.location.protocol + "//" + window.location.hostname + ":3003";
        // wsUrl = "http://192.168.20.14:3000"
        wsUrl = window.location.protocol + "//" + window.location.hostname + ":3003";
      }
      that.aiWebSocket = io.connect(wsUrl, opts);

      that.aiWebSocket.on("webPushNoCid", function (obj) {
        obj = JSON.parse(obj);
        if (obj.content.newLiaisonRecord) {
          that.$refs.ai.flushDispatcherLiaison(obj.content.tdoId,"newLiaisonRecord");
          EventBus.$emit('flushTdoQuote',{"tdoId":obj.content.tdoId});
        }else if (obj.content.newQuoteRecode) {
          that.$refs.ai.flushDispatcherLiaison(obj.content.tdoId,"newQuoteRecode");
          EventBus.$emit('flushTdoQuote',{"tdoNo":obj.content.tdoNo});
        }
      });
      that.aiWebSocket.on("webPush", function (obj) {
        console.log("aiWebSocket.io.push : webPush:", obj);
        // obj = JSON.parse(obj);
        if (obj.newQuote) {
          that.newQuoteTag = true;
          that.$refs.ai.flushData();
        }else if (obj.newTdo) {
          that.$refs.ai.flushData();
        }else if (obj.dispatcherOrders != null && obj.dispatcherOrders ==true){
          console.log("aiWebSocket.io 开启")
        }else if (obj.dispatcherOrders != null && obj.dispatcherOrders ==false){
          console.log("aiWebSocket.closeBar 关闭")
          // that.$refs.ai.closeBar(false);
        }else if (obj.newDriverCallRecord) {
          that.$refs.ai.flushData();
          EventBus.$emit('flushTdoQuote',{"tdoNo":obj.content.tdoNo});
        }

      });
    },

    //************************ */
     handleResize() {
      // 更新容器尺寸
      this.containerWidth = window.innerWidth;
      this.containerHeight = window.innerHeight;
      
      // 确保工具栏在窗口内（可选）
      this.keepInBounds();
    },
    startDrag(event) {
      // 兼容鼠标和触摸事件
      const e = event.type.includes('mouse') ? event : event.touches[0];
      
      // 设置拖拽状态
      this.isDragging = true;
       this.hasDragged = false; // 开始拖动时重置标志
      
      // 计算初始位置和偏移量
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.offsetX = this.positionX;
      this.offsetY = this.positionY;
      
      // 阻止事件冒泡和默认行为
      event.preventDefault();
      event.stopPropagation();
      
      // 添加拖拽样式
      document.body.classList.add('dragging-toolbar');

      // 在 document 上监听 mousemove 和 mouseup 事件
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.endDrag);
      document.addEventListener('touchmove', this.onDrag);
      document.addEventListener('touchend', this.endDrag);
    },
    onDrag(event) {
      if (!this.isDragging) return;
      
      // 兼容鼠标和触摸事件
      const e = event.type.includes('mouse') ? event : event.touches[0];
      
      // 计算新位置
      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;
      this.positionX = this.offsetX + deltaX;
      this.positionY = this.offsetY + deltaY;

       // 标记为已拖动
      this.hasDragged = true; 

      // 阻止事件冒泡和默认行为
      event.preventDefault();
      event.stopPropagation();
    },
    endDrag() {
      // 重置拖拽状态
      this.isDragging = false;

      // 移除 document 上的事件监听
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.endDrag);
      document.removeEventListener('touchmove', this.onDrag);
      document.removeEventListener('touchend', this.endDrag);

      // 移除拖拽样式
      document.body.classList.remove('dragging-toolbar');
    },
    keepInBounds() {
      // 确保工具栏在窗口内（可选）
      const toolbar = this.$el;
      if (!toolbar) return;
      
      const toolbarWidth = toolbar.offsetWidth;
      const toolbarHeight = toolbar.offsetHeight;
      
       console.log('positionX:', this.positionX, 'positionY:', this.positionY);
      // 限制在窗口范围内
      this.positionX = Math.max(0, Math.min(this.containerWidth - toolbarWidth, this.positionX));
      this.positionY = Math.max(0, Math.min(this.containerHeight - toolbarHeight, this.positionY));
    }
  },
};
</script>
<style lang="less" scoped>
.toolBar .rightBottomPanel {
  position: fixed;
  // bottom: 50px;
  // right: 0;
  width: 80px;
  background-color: #eff8fc;
  z-index: 9998;
}

.toolBar .rightBottomPanel .item {
  text-align: center;
  height: 50px;
  padding: 5px 0;
  cursor: pointer;
}

.toolBar .rightBottomPanel .item:hover {
  background-color: #deebfd;
}

.toolBar .rightBottomPanel .item .icon {
  width: 28px;
  height: 28px;
}

.toolBar .rightBottomPanel .item .label {
  color: #747d88;
  font-size: 11px;
  font-weight: 600;
}

.iconDot{
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  right: 22px
}
</style>